// import Glide from '@glidejs/glide';
import Luminous, { LuminousGallery } from 'luminous-lightbox';
import Swiper from 'swiper';

export default class Property {

    constructor() {
        this.detailSlider();
        this.readmore();
        this.luminous();
    }

    detailSlider() {
        if (document.querySelector('#property #property-slider')) {

            const swiper = new Swiper('#property #property-slider .swiper-container', {
                sliderPerView: 1,

                navigation: {
                    nextEl: '#property-slider .swiper-button-next',
                    prevEl: '#property-slider .swiper-button-prev',
                },
            });

        }
    }

    readmore() {
        if (document.querySelector('#property') || document.querySelector('#project')) {
            const text = document.querySelector('#omschrijving .text');
            const height = text.offsetHeight;
            const readmore = document.querySelector('#omschrijving .read-more');

            // Set height of description
            text.style.height = '285px';

            readmore.addEventListener('click', function(ev) {
                ev.preventDefault();

                text.style.height = height + 'px';

                readmore.style.display = 'none';
            });
        }
    }

    luminous() {
        new LuminousGallery(document.querySelectorAll('#fotos .foto .luminous'));
        new LuminousGallery(document.querySelectorAll('#plattegronden .foto .luminous'));
    }
}
